function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

import React, { createRef, forwardRef, useMemo } from "react";
import { register } from "@diana-ui/registry";
import { PopoverStyles } from "@diana-ui/popover";
import * as DropdownStyles from "./Dropdown.style";
export var DropdownHeader = _ref => {
  var { text } = _ref;
  return /*#__PURE__*/ React.createElement(
    DropdownStyles.StyledHeader,
    null,
    /*#__PURE__*/ React.createElement(DropdownStyles.StyledText, null, text)
  );
};
var BaseDropdown = /*#__PURE__*/ forwardRef((props, ref) => {
  var {
    className,
    disabled,
    items,
    onItemSelected,
    selectedItem,
    label,
    placeholder,
    text,
    renderItem,
    renderHeader
  } = props;

  if (!ref) {
    // eslint-disable-next-line no-param-reassign
    ref = /*#__PURE__*/ createRef();
  }

  var isEmpty = useMemo(() => items.length === 0, [items.length]);
  var renderCustomHeader = useMemo(
    () =>
      renderHeader ||
      (() =>
        /*#__PURE__*/ React.createElement(DropdownHeader, {
          text:
            text !== null && text !== void 0 ? text : selectedItem ? selectedItem.text : placeholder
        })),
    [placeholder, renderHeader, selectedItem, text]
  );
  return /*#__PURE__*/ React.createElement(
    DropdownStyles.Wrapper,
    {
      className: [className, isEmpty ? "empty" : ""].join(" ")
    },
    label && /*#__PURE__*/ React.createElement(DropdownStyles.StyledLabel, null, label),
    /*#__PURE__*/ React.createElement(
      DropdownStyles.StyledPopover,
      _extends({}, props, {
        disabled: disabled !== null && disabled !== void 0 ? disabled : items.length === 0,
        renderHeader: renderCustomHeader,
        useParentWidth: true,
        ref: ref
      }),
      !isEmpty &&
        /*#__PURE__*/ React.createElement(
          DropdownStyles.List,
          null,
          items.map((item, index) => {
            var _renderItem;

            return /*#__PURE__*/ React.createElement(
              DropdownStyles.Item,
              {
                className: [
                  (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) ===
                  item.id
                    ? "selected"
                    : "",
                  item.disabled ? "disabled" : ""
                ].join(" "),
                key: item.id,
                onClick: () => {
                  if (!item.disabled) {
                    onItemSelected === null || onItemSelected === void 0
                      ? void 0
                      : onItemSelected(item);
                    ref.current.hide();
                  }
                },
                role: "presentation",
                title: item.text
              },
              (_renderItem =
                renderItem === null || renderItem === void 0
                  ? void 0
                  : renderItem(
                      item,
                      selectedItem !== undefined && selectedItem.id === item.id,
                      index
                    )) !== null && _renderItem !== void 0
                ? _renderItem
                : /*#__PURE__*/ React.createElement(DropdownStyles.ItemText, null, item.text)
            );
          })
        )
    )
  );
});
BaseDropdown.displayName = "Dropdown";
register(BaseDropdown);
export { DropdownStyles, PopoverStyles };
export default BaseDropdown;
